import { initReactI18next } from "react-i18next"

import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import moment from "moment"

import { loadResources } from "./loadResources"

const FALLBACK_LNG = "en"
const LOCAL_STORAGE_KEY = "i18nextLng"

export function initI18n(): typeof i18n {
  if (i18n.isInitialized) return i18n

  const resources = loadResources()

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: FALLBACK_LNG,
      supportedLngs: Object.keys(resources),
      nonExplicitSupportedLngs: true,
      debug: import.meta.env.DEV,
      detection: {
        order: ["localStorage", "navigator", "htmlTag"],
        caches: ["localStorage"],
        lookupLocalStorage: LOCAL_STORAGE_KEY,
      },
    })

  return i18n
}

let spanishLocaleLoaded = false

const loadSpanishLocale = (): void => {
  if (!spanishLocaleLoaded) {
    moment.defineLocale("es", {
      months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
      monthsShort: "Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic".split("_"),
      weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
      weekdaysShort: "dom_lun_mar_mié_jue_vie_sáb".split("_"),
      weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D [de] MMMM [de] YYYY",
        LLL: "D [de] MMMM [de] YYYY H:mm",
        LLLL: "dddd, D [de] MMMM [de] YYYY H:mm",
      },
      relativeTime: {
        future: "en %s",
        past: "hace %s",
        s: "unos segundos",
        ss: "%d segundos",
        m: "un minuto",
        mm: "%d minutos",
        h: "una hora",
        hh: "%d horas",
        d: "un día",
        dd: "%d días",
        w: "una semana",
        ww: "%d semanas",
        M: "un mes",
        MM: "%d meses",
        y: "un año",
        yy: "%d años",
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: (num: number): string => num + "º",
      week: { dow: 1, doy: 4 },
      invalidDate: "Fecha inválida",
    })
    spanishLocaleLoaded = true
  }
}

const applyMomentLocale = (lng: string): void => {
  if (lng === "es") {
    loadSpanishLocale()
  }
  moment.locale(lng)
}

applyMomentLocale(i18n.resolvedLanguage || i18n.language)
i18n.on("languageChanged", applyMomentLocale)
